const BASE = '/v1/config/service-categories';
export class ServiceCategoriesApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Versions and status rows, optionally narrowed to a bucket and a code (a bucket + code also returns the trail). */
    list(filter = {}) {
        const q = new URLSearchParams();
        if (filter.scope !== undefined)
            q.set('scope', filter.scope);
        if (filter.scopeRef !== undefined)
            q.set('scopeRef', filter.scopeRef);
        if (filter.code !== undefined)
            q.set('code', filter.code);
        const qs = q.toString();
        return this.client.request({ method: 'GET', path: qs === '' ? BASE : `${BASE}?${qs}`, auth: true });
    }
    /** What a market resolves now: every category with an entry in its ancestry, its status and its fare. */
    market(marketId) {
        return this.client.request({ method: 'GET', path: `${BASE}/markets/${encodeURIComponent(marketId)}`, auth: true });
    }
    propose(input) {
        return this.client.request({ method: 'POST', path: `${BASE}/proposals`, body: input, auth: true });
    }
    decide(input) {
        return this.client.request({ method: 'POST', path: `${BASE}/decisions`, body: input, auth: true });
    }
    deactivate(input) {
        return this.client.request({ method: 'POST', path: `${BASE}/deactivations`, body: input, auth: true });
    }
    requestReactivation(input) {
        return this.client.request({ method: 'POST', path: `${BASE}/reactivations`, body: input, auth: true });
    }
    decideReactivation(input) {
        return this.client.request({ method: 'POST', path: `${BASE}/reactivations/decisions`, body: input, auth: true });
    }
    copy(input) {
        return this.client.request({ method: 'POST', path: `${BASE}/copies`, body: input, auth: true });
    }
}
//# sourceMappingURL=service-categories.js.map